import React, { Component, Fragment } from 'react';
import { Button, Container, Row, UncontrolledAlert } from 'reactstrap';
import cubeApiClient from '../BusinessObjects/cubeApiService';
import LoggedContext from '../BusinessObjects/LoggedContext';
import EsaedroResourceAttachment from '../Models/EsaedroResourceAttachment';
import EsaedroAttachment from './EsaedroAttachment';
import EsaedroObjectDelete from './EsaedroObjectDelete';

/************** COMPONENTE CHE MOSTRA GLI ALLEGATI DI UNA RISORSA *****************/
/************** Da qui è solamente possibile visualizzarli ed eliminarli **********/

interface IEsaedroAttachmentsControllerProps {
    Resource_ID: number,
    Item_ID: number
}

interface IEsaedroAttachmentsControllerState {
    loading: boolean,
    successMessage: string,
    errorMessage: string,
    attachments: EsaedroResourceAttachment[],
    attachmentToDelete: any
}

export default class EsaedroAttachmentsController extends Component<IEsaedroAttachmentsControllerProps, IEsaedroAttachmentsControllerState> {

  static contextType = LoggedContext
  context!: React.ContextType<typeof LoggedContext>
  
  constructor(props: IEsaedroAttachmentsControllerProps){
    super(props);

    this.state = {
      loading: false,
      successMessage: "",
      errorMessage: "",
      attachments: [],
      attachmentToDelete: null
    };
}

  componentDidMount() {
    this.getObjectAttachments()
  }

  getObjectAttachments = () => {
    // Faccio una chiamata ai webservice con le immagini legate all'oggetto
    this.setState({loading: true})
  
    const service = new cubeApiClient();
    const t = this.context.tokenAPI;
    const requrl = 'api/sys/ResourcesAttachments?RecordSelection=' + "Resource_ID=" + this.props.Resource_ID + "and Item_ID=" + this.props.Item_ID

    service
        .getItems(requrl,t)
        .then((data: any) => {
            // Aggiorno i miei attachments
            if (data)
            {
              this.setState({
                attachments:data,
                loading:false
              })
            }
            else {
              this.setState({
                errorMessage:"Errore nello scaricare gli allegati",
                loading: false
              })
            }
        },
        (error: any) => {
            this.setState({ 
              attachments:[],
              errorMessage: error,
              loading: false
            });
        });
  }

  onDeleteButtonPressed = (attachmentToRemove: EsaedroResourceAttachment) => {
    this.setState({attachmentToDelete: attachmentToRemove})
  }

  onAttachmentRemoved = (returnMessage: string) => {
    // Mostro il messaggio di successo e rendo nullo l'attachment da rimuovere
    this.setState({successMessage: returnMessage, attachmentToDelete: null})
    // Dopodichè ricarico gli allegati
    this.getObjectAttachments()
  }
  
  render() {
    const { loading, attachments, attachmentToDelete } = this.state

    const successMessageAlert =  (
      (this.state.successMessage != '')?
        <UncontrolledAlert color="success">
          {this.state.successMessage}
        </UncontrolledAlert>
      : undefined
    )

    const errorMessageAlert =  (
        (this.state.errorMessage != '')?
          <UncontrolledAlert color="danger">
            {this.state.errorMessage}
          </UncontrolledAlert>
        : undefined
    
    )

    const content = (
                      loading? 
                        <div>Caricamento...</div>
                      :attachmentToDelete?
                        <EsaedroObjectDelete 
                              myObjType={"ResourcesAttachments"} 
                              myObjUrl={"api/sys/ResourcesAttachments"} 
                              myObj={attachmentToDelete} 
                              onReturn={this.onAttachmentRemoved}>
                        </EsaedroObjectDelete> 
                      :(attachments.length > 0)?
                        attachments.map((attachment: EsaedroResourceAttachment, i: number) => 
                          <Row>
                            <EsaedroAttachment 
                                  key={i} 
                                  attachment={attachment.Content} 
                                  attachmentFieldName={""} 
                                  name={attachment.Description} 
                                  canLoad={false} 
                                  canDelete={true} 
                                  resourceAttachment={attachment} 
                                  onDelete={this.onDeleteButtonPressed}>
                            </EsaedroAttachment>
                            &nbsp;
                          </Row>  
                        )
                      :<span>Nessun allegato da visualizzare</span> 
                    )
      
    return (
      <Container>
        {successMessageAlert}
        <Row>
          &nbsp;
        </Row>
        {errorMessageAlert}
        <Row>
          &nbsp;
        </Row>
        {content}
      </Container>
    )
  }
}